import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { User } from "@task-modules/users";
import { Task } from "@task-utils/types";
import { TaskRoutes } from "@task-utils/routes";
import { color, ConfirmDialogComponent, Frame, language, modal } from "curvy";
import { company_settings_translations } from "./company-settings.trans";


enum RIGHTS {
   NONE = 0,
   VIEW = 1,
   EDIT = 2
}


@Component({
   selector: "task-company-settings",
   templateUrl: "./company-settings.component.html",
   styleUrls: ["./company-settings.component.scss"],
   encapsulation: ViewEncapsulation.None,
})
export class CompanySettingsComponent implements OnInit {
   constructor( ) {
      language.load_translations(company_settings_translations);
      Frame.set({
         title: language.translate("COMPANY_SETTINGS"),
         visible: true,
         layout: "top-middle",
         size: "scroll"
      });
   }

   get company_logo() {
      if (!this.company.company_logo) {
         return 'assets/icons/task-logo.svg';
      }
      return TaskRoutes.upload.uploaded_file_get(this.company.company_logo);
   }

   user: User.Current | null = null;
   COMPANY_RIGHTS = {
      insurers: RIGHTS.NONE
   }
   company: Task.Company;

   new_insurers: string[] = [];

   async init() {
      this.user = await User.currentUserPromise;

      switch (this.user.user_type_id) {
         case Task.USER_TYPE.SYSTEM_ADMIN:
         case Task.USER_TYPE.ADMIN:
         case Task.USER_TYPE.INSURANCE_MANAGER:
            this.COMPANY_RIGHTS.insurers = RIGHTS.EDIT;
            break;
         default:
            this.COMPANY_RIGHTS.insurers = RIGHTS.NONE;
            break;
      }

      await this.update_values();
   }

   ngOnInit(): void {
      this.init();

   }

   async update_values() {
      this.company = (await TaskRoutes.companies.api_company_get_single(this.user.company_id)).data;
   }

   add_insurer() {
      this.new_insurers.push("");
   }

   delete_insurer(insurer: string) {
      modal.open(
         ConfirmDialogComponent,
         async (ok) => {
            if (!ok) return;

            this.company.insurers = this.company.insurers.filter(i => i!==insurer);
            await TaskRoutes.companies.api_company_modify(
               this.company.company_id,
               { insurers: this.company.insurers }
            );

            this.update_values();
         }, {
            title: language.translate("COMPANY_SETTINGS.DELETE_INSURER.TITLE"),
            message: language.translate("COMPANY_SETTINGS.DELETE_INSURER.MSG", insurer),
            icon: "ballot",
            iconColor: color.variable(color.Variable.warn)
         }
      );
   }

   async save_new_insurer(insurer: string) {
      this.new_insurers.splice(this.new_insurers.indexOf(insurer), 1);
      await TaskRoutes.companies.api_company_modify(
         this.company.company_id,
         {insurers: [...this.company.insurers, insurer]}
      );
      this.update_values(); // TODO: it might be better to load only insurers when the endpoint is ready
   }
}
